import { emsClient } from '../api/clients';

export async function activateLiveVideo(incidentId: string): Promise<Response> {
  const { response } = await emsClient().POST('/v1/incidents/{incidentId}/caller/live-video/activate', {
    params: { path: { incidentId } },
  });

  return response;
}
